module.exports = __webpack_public_path__ + "media/entertainment.0ad77e85.mp4";